import React from 'react';
import { Box, BoxProps } from '@mui/material';

import { Spinner } from '../Spinner';

interface IQueryLoadingProps extends Pick<BoxProps, 'sx'> {
  isAbsolute?: boolean;
  size?: number;
}

export function QueryLoading({
  isAbsolute,
  sx,
  size = 40,
}: IQueryLoadingProps): JSX.Element {
  return (
    <Box
      sx={{
        color: 'text.primary',
        fontSize: 40,
        ...sx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(isAbsolute
          ? {
              position: 'absolute',
              top: `calc(50% - ${size / 2}px )`,
              left: `calc(50% - ${size / 2}px)`,
            }
          : {}),
      }}
    >
      <Spinner sx={{ fontSize: 'inherit' }} />
    </Box>
  );
}
